import styled from 'styled-components'
import { tokens, Tabs } from '@arvoreeducacao/bonsai-ds'
import { Modal } from '../../../lib/modals'

export const StyledModal = styled(Modal)`
  max-width: 500px;
  width: 100%;
  min-height: 400px;
  padding-left: ${tokens.spacing.spacing_8}px;
  padding-right: ${tokens.spacing.spacing_8}px;
`

export const ModalHeader = styled.div`
  margin: -45px 0 0;

  h2 {
    color: var(--dark-color-dark-6, ${tokens.colors.dark6});
    text-align: center;
    font-size: ${tokens.fontSize.large};
    font-weight: ${tokens.fontWeights.bold};
    line-height: ${tokens.lineHeight.medium}%;
  }
`

export const StyledTabs = styled(Tabs)`
  margin-bottom: 2rem;
`
